import { QrReader } from 'react-qr-reader'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  ButtonProps,
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useTheme
} from '@mui/material'
import { useDialog } from '../hooks'
import { Camera, CameraAlt, Close } from '@mui/icons-material'

export interface QrReaderButtonProps extends Omit<
  ButtonProps,
  'children' | 'onClick' | 'onChange'
> {
  onChange: (code: string) => void
  slotProps?: {
    dialog?: Omit<DialogProps, 'children' | 'open' | 'onClose'>
  }
}

export default function QrReaderButton({ onChange, slotProps, ...props }: QrReaderButtonProps) {
  const { t } = useTranslation('actions')

  const theme = useTheme()

  const { open, openDialog, closeDialog } = useDialog()

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<CameraAlt />}
        onClick={openDialog}
        {...props}
      >
        {t('readQrCode')}
      </Button>

      <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="xs" {...slotProps?.dialog}>
        <DialogTitle>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Typography variant="h6">{t('readQrCode')}</Typography>
            <IconButton onClick={closeDialog}>
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ p: 0, position: 'relative' }}>
          <Box
            sx={{
              background: `linear-gradient(to right, white 4px, transparent 4px) 0 0,
                linear-gradient(to right, white 4px, transparent 4px) 0 100%,
                linear-gradient(to left, white 4px, transparent 4px) 100% 0,
                linear-gradient(to left, white 4px, transparent 4px) 100% 100%,
                linear-gradient(to bottom, white 4px, transparent 4px) 0 0,
                linear-gradient(to bottom, white 4px, transparent 4px) 100% 0,
                linear-gradient(to top, white 4px, transparent 4px) 0 100%,
                linear-gradient(to top, white 4px, transparent 4px) 100% 100%`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '20px 20px',
              aspectRatio: '1 / 1',
              width: '75%',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1
            }}
          ></Box>
          <QrReader
            scanDelay={500}
            constraints={{ facingMode: 'environment', aspectRatio: 9 / 16 }}
            onResult={(result) => {
              if (result) {
                onChange(result.getText())
              }
            }}
            containerStyle={{ width: '100%' }}
            videoContainerStyle={{
              position: 'relative',
              width: '100%',
              paddingTop: '177.78%',
              backgroundColor: 'black',
              overflow: 'hidden'
            }}
            videoStyle={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
